export default {
    data: () => ({
        translations: {
            linkText: {
                el: "Χρησιμοποίησε επίσης το documentation για να χρησιμοποιήσεις το RoadCube Api:",
                en: "Use our official documentation to use our API:",
                it: "Utilizza la nostra documentazione ufficiale per utilizzare la nostra API: "
            },
        }
    })
};
